/**
 * XNGAGE CONFIDENTIAL
 * __________________________
 *
 * Copyright (C) 2020 Xngage - All Rights Reserved
 *
 * All code or information contained herein is, and remains the
 * property of Xngage LLC and its customers.  The intellectual
 * and technical concepts contained are proprietary to Xngage LLC
 * and may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Xngage LLC.
 */
import { TypographyPresentationProps, TypographyProps } from "@insite/mobius/Typography";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import { css } from "styled-components";

export interface InfoDisplayStyles {
    headerText?: TypographyPresentationProps;
    wrapper?: InjectableCss;
    titleText?: TypographyProps;
    contentText?: TypographyProps;
}

export const infoDisplayStyles: InfoDisplayStyles = {
    wrapper: {
        css: css`
            margin-bottom: 5px;
            width: 100%;
            display: flex;
            align-items: center;
            flex-wrap: wrap;
        `,
    },
    headerText: {
        variant: "h5",
        css: css`
            @media print {
                font-size: 12px;
            }
            margin-bottom: 5px;
        `,
    },
    titleText: {
        variant: "h6",
        as: "h2",
        css: css`
            margin-bottom: 0;
            padding-right: 2px;
            white-space: nowrap;
        `,
    },
    contentText: {
        css: css`
            text-align: right;
            line-height: 20px;
            white-space: nowrap;
        `,
        ellipsis: true,
    },
};

export const infoDisplayStylesTwo: InfoDisplayStyles = {
    headerText: {
        variant: "h5",
        css: css`
            @media print {
                font-size: 12px;
            }
            margin-bottom: 5px;
        `,
    },
    wrapper: {
        css: css``,
    },
    titleText: {
        variant: "h6",
        as: "h2",
        css: css`
            margin-bottom: 5px;
        `,
    },
    contentText: {
        css: css``,
    },
};
